import { Hyperlink } from '@fable/components'

export const defaultFaqList = [
  {
    title: 'How is Fable’s reader different from Kindle?',
    description:
      'Kindle is a straightforward e-reader; Fable is an interactive e-reader that includes social features inside the ebooks. When you read an ebook on Fable, you can see and react to the text with others in real time. Start a discussion, share highlights and quotes, add emoji reactions, create private tabs — all of it lives right inside the book. It’s hard to explain and easy to see, so we recommend reading the free sample in one of our most active book clubs to get a feel for it.',
  },
  {
    title: 'What are some other benefits of reading on Fable?',
    description:
      'We love being able to read anytime, anywhere, without having to carry around a physical book or another piece of hardware. We find ourselves reading more and accomplishing our reading goals faster by using our screentime for reading rather than scrolling on social media. If you’re open to a new type of reading experience, we hope you’ll give Fable ebooks a try! One more thing: We donate 20% of every book sale to the World Literacy Foundation to help children learn to read. We would be honored to have your support in that effort.',
  },
  {
    title: 'Is the Fable app free to download?',
    description:
      'Yes! Fable is completely free to download on iOS and Android devices. You’ll get access to join over 10,000 online book clubs, or you can start your own club! You’ll also get free list-building tools and a curated For You feed filled with content from like-minded readers. You can download a free sample of any book in our catalog, and if you want to keep reading, you have the option to purchase the full ebook and read it on the app.',
  },
  {
    title: 'How do I purchase books to read on Fable?',
    description: (
      <>
        App store rules only allow us to sell a few hundred books through the
        iOS app, but you can purchase any book in our catalog of over a million
        titles from the Fable webstore (
        <Hyperlink href="https://fable.co/store" newTab>
          www.fable.co/store
        </Hyperlink>
        ), and we’ll automatically add it to your bookshelf in the app. We know,
        it’s a pain, but we’ve tried to make it a little easier by enabling
        in-app purchases for the most popular titles. For these books, you’ll
        see the purchase price right inside the app, where you can buy and
        download the full book right away.
      </>
    ),
  },
  {
    title: 'Can I try it for free before I buy a book?',
    description:
      'Absolutely! Just like you would open a physical book in a bookstore to read a few pages, we wanted to make it super easy to sample books before you purchase them from Fable. In the Fable app, you can read a free sample and explore the interactive reading features before you decide to purchase any book in our catalog. You can even join a book club, sample the club’s book, and see all of the members’ activity inside the book. If you do decide to purchase, you’ll get access to the full book right away.',
  },
  {
    title: 'Do you sell physical books or audiobooks?',
    description:
      'Not at the moment. But, if you prefer to read physical books or listen to audiobooks on your platform of choice, you can still join the discussion happening inside any book club on Fable. Reading the ebook on Fable provides a richer, more integrated experience with your club, but it’s not required!',
  },
]
